import {Image} from "antd";
import React from "react";
import {ConversationMessageMediaItemProps} from "./ConversationMessageMedia";

const ConversationMediaImage = ({ mediaItem, text }: { mediaItem: ConversationMessageMediaItemProps, text: string }) => {
    return <Image
        src={mediaItem.url}
        alt={text}
        preview={{
            mask: null,
            getContainer: () =>
                document.getElementById("conversation-image-preview-modal") as HTMLElement,
        }}
        style={{cursor: "pointer", minWidth: 200, minHeight: 200}}
    />
}

export default ConversationMediaImage;